import React from "react";
import { DEFAULT_LIMIT } from "../../../constants";
import styled from "styled-components";
import PaginationWrapper from "../../../components/shared/pagination/PaginationWrapper";
import FilterContent from "./filters-table/FilterContent";
import { Grid } from "@mui/material";

const MainContainer = styled.div`
  margin-top: 0.25rem;
  width: 100%;
`;

const initialValues = {
    fetching: false,
    prevTokens: [],
    nextToken: null,
    nextData: 0,
    limit: DEFAULT_LIMIT,
    data: [],
    sortDirection: "ASC",
    orderBy: "filterName",
    refreshData: 0,
};

const FilterMainPage = ({ showMyFilters, registerUpdateFn, registerTriggerFetch }) => {
    return (
        <MainContainer>
            <Grid container spacing={3}>
                <Grid item md={12}>
                    <PaginationWrapper initialValues={initialValues}>
                        <FilterContent showMyFilters={showMyFilters} registerTriggerFetch={registerTriggerFetch} registerUpdateFn={registerUpdateFn}/>
                    </PaginationWrapper>
                </Grid>
            </Grid>
        </MainContainer>
    );
};

export default FilterMainPage;
